/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Loading from "../../components/loading";

const DataBank = ({ data, type }) => {
  return (
    <>
      {data ? (
        <div className='container'>
          <div className='callback'>
            <img src='/images/success.png' alt='success' />
            <h4 className='text-center'>پرداخت شما باموفقیت ثبت شد</h4>
            <div className='bottom-callback'>
              <div className='banner_callback'>
                <span>شماره تراکنش</span>
                {type == 2 ? (
                  <span>{data.ref}</span>
                ) : (
                  <span>{data.trackingCode}</span>
                )}
              </div>
              {type == 1 && (
                <a href={"/product-list"} className='btn_callback'>
                  مشاهده سفارشات من
                </a>
              )}
              {type == 2 && (
                <a
                  href={`/document/${data.document._id}`}
                  className='btn_callback'
                >
                  بازگشت به سایت
                </a>
              )}
              {type == 3 &&
                (data.reserveTime.date ? (
                  <a
                    href={`/profile-lawyer/${localStorage.getItem(
                      "consultingId"
                    )}`}
                    className='btn_callback'
                  >
                    مشاهده زمان تعیین شده
                  </a>
                ) : (
                  <a
                    href={`/calendar/${data.lawyer._id}`}
                    className='btn_callback'
                  >
                    تعیین زمان مشاوره
                  </a>
                ))}
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};
export default DataBank;
